// Shared Configuration ID helpers for calculator cart add-ons
(function() {
  'use strict';

  function encodeTapping(tapping) {
    if (tapping === 'tap both ends M8') return 'Tb';
    if (tapping === 'tap one end M8' || tapping === 'tap left end M8' || tapping === 'tap right end M8') return 'T1';
    return 'Tn';
  }

  function encodeHoles(holes) {
    if (!holes || !String(holes).trim()) return '';

    let encoded = '';
    String(holes).split('\n').filter(function(line) { return line.trim(); }).forEach(function(holeLine) {
      const diamMatch = holeLine.match(/(\d+)mm/);
      const posMatch = holeLine.match(/, (\d+)mm,/);
      const railMatch = holeLine.match(/(Top|Side) Slot/);

      if (diamMatch && posMatch && railMatch) {
        const orientation = railMatch[1] === 'Top' ? 'TB' : 'FB';
        encoded += 'H' + diamMatch[1] + orientation + posMatch[1];
      }
    });

    return encoded;
  }

  function generateConfigId(variantId, lengthMm, tapping, holes) {
    const vid = variantId || 'unknown';
    return 'V' + vid + '_L' + lengthMm + encodeTapping(tapping || '') + encodeHoles(holes || '');
  }

  function isCustomizationItem(item) {
    if (!item) return false;

    const title = (item.title || '').toLowerCase();
    const handle = (item.handle || '').toLowerCase();
    const properties = item.properties || {};

    if (title.includes('customization') || title.includes('customisation') || handle.includes('customization')) {
      return true;
    }

    if (properties['Unit Fee'] && properties['Base Quantity']) {
      return true;
    }

    return item.price === 1;
  }

  function getCustomizationTarget(item) {
    const properties = item.properties || {};
    return properties['For'] || properties['Configuration for'] || '';
  }

  function getGroupKeyFromCartItem(item) {
    const properties = item.properties || {};
    const configId = properties['Configuration ID'];
    if (!configId) return null;

    if (isCustomizationItem(item)) {
      return configId + '::' + getCustomizationTarget(item);
    }

    return configId + '::' + (item.title || '');
  }

  window.AMECartConfig = {
    generateConfigId: generateConfigId,
    encodeTapping: encodeTapping,
    encodeHoles: encodeHoles,
    isCustomizationItem: isCustomizationItem,
    getCustomizationTarget: getCustomizationTarget,
    getGroupKeyFromCartItem: getGroupKeyFromCartItem
  };
})();
